export default __webpack_public_path__ + "static/media/self&spouse.4f569821.svg";